import { IconButton, Tooltip, useColorModeValue } from '@chakra-ui/react';
import { faMap } from '@fortawesome/free-solid-svg-icons';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { useViewer } from './ForgeViewer';
import SparkelIcon from './icon/SparkelIcon';
import { useViewerMode, ViewerMode } from './viewer-mode';

export default function CameraModeButton(): React.ReactElement | null {
  const { viewerMode } = useViewerMode();
  const { isOrthographicModeActive, setOrthographicMode } = useViewer();
  const activeIconColor = useColorModeValue('teal.500', 'teal.200');

  const { t } = useTranslation('project');

  if (viewerMode === ViewerMode.Sheets) {
    return null;
  }
  return (
    <Tooltip label={t('orthographic-mode-button')}>
      <IconButton
        aria-label="Toggle ortographic mode"
        icon={
          <SparkelIcon
            icon={faMap}
            color={isOrthographicModeActive ? activeIconColor : undefined}
          />
        }
        isRound
        isActive={isOrthographicModeActive}
        colorScheme={isOrthographicModeActive ? 'teal' : 'gray'}
        variant={isOrthographicModeActive ? 'toggle' : 'solid-no-transparent'}
        size="xs"
        onClick={() => {
          setOrthographicMode(!isOrthographicModeActive);
        }}
      />
    </Tooltip>
  );
}
